import {ApplicationType} from "@/api-client";
import {ls} from "@/CultureService";

export default function translateApplicationType(type: ApplicationType): string {
    switch (type) {
        case ApplicationType.NewCertificate:
            return ls.Applications_ApplicationType_NewCertificate
        case ApplicationType.NewEndorsement:
            return ls.Applications_ApplicationType_NewEndorsement
        case ApplicationType.Duplicate:
            return ls.Applications_ApplicationType_Duplicate
        default:
            return type;
    }
}